const getters = {
    calendar: state => state.Talent.calendarLists
};
export default getters;
  